const faqs = [
  {
    question: "Does Pennsylvania have its own regional passport agency?",
    answer:
      "Pennsylvania does not have a dedicated state-level passport agency. The nearest regional passport agency for most of Pennsylvania is the Philadelphia Passport Agency, located in Center City Philadelphia. Western PA residents may also consider the Detroit Passport Agency or Cleveland Passport Agency depending on appointment availability and travel distance.",
  },
  {
    question: "How fast can I get a passport in Pennsylvania?",
    answer:
      "With Fast Passport Center's courier service, Pennsylvania travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Pennsylvania?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or municipal building). Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which Pennsylvania airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major Pennsylvania international airports include Philadelphia (PHL), Pittsburgh (PIT), Lehigh Valley (ABE), and Harrisburg (MDT).",
  },
  {
    question: "Can I renew by mail from Pennsylvania?",
    answer:
      "Yes — if your most recent passport is undamaged, was issued when you were 16 or older, and was issued within the last 15 years, you can renew by mail from any Pennsylvania address. Include a recent 2×2 photo and a check or money order.",
  },
  {
    question: "Where is the best place to get a passport photo in Pennsylvania?",
    answer:
      "CVS, Walgreens, and UPS Stores are widely available across Pennsylvania from Philadelphia to Pittsburgh and everywhere in between. Most accept walk-ins, but calling ahead is smart — especially in Center City Philadelphia and downtown Pittsburgh where wait times can be longer.",
  },
];

export { faqs };

export default function PennsylvaniaFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Pennsylvania Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Pennsylvania.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}